// Restore Digital Game promotions by changing this single flag to true.
export const SHOW_DIGITAL_GAME = false
